import { supabaseDataProvider } from 'ra-supabase-core'
import { supabaseClient } from './'

function replaceSpacesWithUnderscores(obj) {
  if (typeof obj !== 'object') return obj

  const result = {}

  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      const modifiedValue = obj[key].replace(/\s/g, '_')
      result[key] = modifiedValue
    } else {
      result[key] = obj[key]
    }
  }

  return result
}

const raDataProvider = supabaseDataProvider({
  instanceUrl: process.env.REACT_APP_SUPABASE_URL,
  apiKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
  supabaseClient
})

const baseDataProvider = {
  ...raDataProvider,
  getList: async (resource, params) => {
    // clean space in search
    if (params && params.filter) {
      const nbrOfFilters = Object.keys(params.filter)
      if (nbrOfFilters?.length > 0) {
        const newFilters = replaceSpacesWithUnderscores(params.filter)
        params.filter = newFilters
      }
    }

    return raDataProvider.getList(resource, params)
  }
}

export default baseDataProvider